{
  "dashboard": {
    "title": "Dashboard"
  },
  "devices": {
    "title": "S4 – lokale Station"
  },
  "device": {
    "title": "Gerät"
  },
  "dtwins": {
    "title": "Geräte"
  },
  "dtwin": {
    "title": "Gerät LPP4"
  },
  "users": {
    "title": "Benutzer"
  },
  "user": {
    "title": "Benutzer"
  },
  "profiles": {
    "title": "Profile"
  },
  "applications": {
    "title": "Anwendungen"
  },
  "campaigns": {
    "title": "Kampagnen"
  },
  "logs": {
    "title": "Protokolle"
  },
  "sectors": {
    "details": {
      "title": "Einzelheiten zu den Sektoren {name}"
    },
    "title": "Sektoren"
  },
  "parameters": {
    "title": "Parameter"
  },
  "userGroups": {
    "title": "Gruppen"
  },
  "pkiConnector": {
    "title": "PKI-Konnektor"
  },
  "truststore": {
    "title": "Truststore"
  },
  "firmware": {
    "title": "Firmware"
  },
  "filters": "Filter",
  "certificateAlertReporting": {
    "title": "Berichterstattung"
  },
  "certificate-management": {
    "title": "Zertifikate"
  },
  "applicationMgts": {
    "title": "Anwendungen"
  },
  "license": {
    "title": "Lizenz"
  },
  "userAccount": {
    "title": "Benutzerkonto"
  },
  "about": {
    "title": "Info",
    "downloadTitle": "Protokolle herunterladen"
  },
  "deviceConfiguration": {
    "title": "Geräteparametrierung"
  },
  "certificates": {
    "title": "Zertifikate"
  },
  "fleets": {
    "title": "Flotten"
  },
  "businessUnits": {
    "title": "{name} ändern"
  },
  "organizations": {
    "title": "{name} ändern"
  },
  "interfaces": {
    "title": "Schnittstellen"
  }
}
